import { ReactModel } from "../../react-model/react-model";
import { HBusySpinner } from "./h-busy-spinner";

const gid_busy_spinner = 'gid_busy_spinner';

//--------------------------------------------------------------------------------------
// Model
//--------------------------------------------------------------------------------------
const model = new ReactModel({
	model:{
		display: false,
		z_index:0,
	}
})
//--------------------------------------------------------------------------------------
// Controller
//--------------------------------------------------------------------------------------
class GlobalBusySpinner {
	private timer_handle = 0 as any;
	private busy_count = 0;

	public reset() {
		model.setProperty({display:false})
		this._resetTimer();
	}

	public zIndex(z_index:number){
		model.setProperty({z_index});
	}

	private _resetTimer(){
		this.timer_handle && clearTimeout(this.timer_handle);
		this.timer_handle = 0;
	}

	public show(is_show: boolean) {
		if (is_show) {
			this.busy_count++;
			if(this.busy_count === 1){
				this.timer_handle = setTimeout(() => {
					model.setProperty({'display':true});
				}, 300);
			}
		} else {
			if(this.busy_count){
				this.busy_count--;
				if(this.busy_count === 0){
					this.reset();
				}
			}
		}
	}

	public isBusy() {
		return model.getState().display;
	}
}

export const g_busySpinner = new GlobalBusySpinner();

//--------------------------------------------------------------------------------------
// View
//--------------------------------------------------------------------------------------

export function HGlobalBusySpinner() {
	const {state} = model.useModel('display');
	return (
		<div id={gid_busy_spinner} style={{display: (state?'inline-block':'none')}}>
			<HBusySpinner style={{ fontSize: '8em' }} />
		</div>
	);
}
